import React from "react";
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import { Container, Row, Col, Button, Card, Navbar, Image } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../Images/gd.png"; // Ensure the logo path is correct
import './Dashboard.css'

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    alert("You have been logged out!");
    navigate("/");
  };

  return (
    <div className="dashboard-container">
      {/* Navbar */}
      <Navbar className="dashboard-navbar">
        <Container fluid>
          <Navbar.Brand href="#" className="d-flex align-items-center">
            <Image src={Logo} alt="Golden Women" className="logo-img1" />
          
          </Navbar.Brand>
          <span className="brand-text">Golden Women</span>
          <FaSignOutAlt className="logout-icon" size={30} onClick={handleLogout} />
        </Container>
      </Navbar>

      {/* Dashboard Grid */}
      <Container className="dashboard-content">
  <Row className="justify-content-center">
    {[
      { text: "Menu Items", link: "/menu-item-s/menu-items/tems/346734/menuitems" },
      { text: "Advertisement", link: "/advertise" },
      { text: "Membership Levels", link: "/membership-levels" }, 
      { text: "Members", link: "/members" }, 
   
   
     
    ].map((item, index) => (
      <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
        <Link to={item.link} style={{ textDecoration: "none" }}>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Card className="dashboard-card">
              <Card.Body>
                <h4 className="dashboard-card-text">{item.text}</h4>
              </Card.Body>
            </Card>
          </motion.div>
        </Link>
      </Col>
    ))}
  </Row>
</Container>

      {/* Footer */}
      <footer className="dashboard-footer">
        <p>&copy; 2025 EMedha Technologies. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Dashboard;
